import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiftcard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGiftcard"><Path d="M13.25 4H2V11.25H12.1893L10.1893 9.25L11.25 8.18934L13.25 10.1893V4Z" fill="currentColor"/><Path d="M2 12.75V20H13.25V13.8107L11.25 15.8107L10.1893 14.75L12.1893 12.75H2Z" fill="currentColor"/><Path d="M14.75 20H22V12.75H15.8107L17.8107 14.75L16.75 15.8107L14.75 13.8107V20Z" fill="currentColor"/><Path d="M22 11.25V4H14.75V10.1893L16.75 8.18934L17.8107 9.25L15.8107 11.25H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiftcard;
